import type {
  PredictionMarket,
  PredictorLeaderboardItem,
  UserBet,
} from '../types';

export const INITIAL_MARKETS: PredictionMarket[] = [
  {
    id: 'm-btc-100k',
    title: 'Will Bitcoin surpass $105,000 before end of month?',
    category: 'crypto',
    status: 'live',
    isHot: true,
    description:
      'Resolves to YES if Binance BTC/USDT index prints $105,000.00 or higher at any point before the settlement timestamp. Otherwise resolves to NO.',
    rules:
      'Official index feed based on aggregate CEX volume. Instant settlement upon price touch.',
    endsAt: new Date(Date.now() + 36 * 3600 * 1000).toISOString(),
    totalPool: 482500,
    participantsCount: 3180,
    volume24h: 92400,
    options: [
      {
        id: 'opt-yes',
        label: 'YES (Above $105k)',
        odds: 1.82,
        votesPercentage: 58,
        totalStaked: 279850,
        color: '#10b981',
      },
      {
        id: 'opt-no',
        label: 'NO (Below $105k)',
        odds: 2.15,
        votesPercentage: 42,
        totalStaked: 202650,
        color: '#f43f5e',
      },
    ],
  },
  {
    id: 'm-ucl-madrid-mancity',
    title: 'Real Madrid vs Manchester City – UEFA Champions League',
    category: 'sports',
    status: 'live',
    isHot: true,
    description:
      'Who will win the quarter-final leg at the Santiago Bernabéu? Regular 90 minutes + stoppage time only.',
    rules: 'Official UEFA match report determines result.',
    endsAt: new Date(Date.now() + 4 * 3600 * 1000).toISOString(),
    totalPool: 341200,
    participantsCount: 2240,
    volume24h: 115000,
    options: [
      {
        id: 'opt-madrid',
        label: 'Real Madrid',
        odds: 2.35,
        votesPercentage: 45,
        totalStaked: 153540,
        color: '#3b82f6',
      },
      {
        id: 'opt-draw',
        label: 'Draw',
        odds: 3.40,
        votesPercentage: 22,
        totalStaked: 75064,
        color: '#eab308',
      },
      {
        id: 'opt-city',
        label: 'Man City',
        odds: 2.10,
        votesPercentage: 33,
        totalStaked: 112596,
        color: '#06b6d4',
      },
    ],
  },
  {
    id: 'm-t1-geng-finals',
    title: 'T1 vs Gen.G – League of Legends Champions Korea Final',
    category: 'esports',
    status: 'live',
    isHot: true,
    description:
      'Grand Finals Best-of-5 series. Predict the winner of the championship match.',
    rules: 'Official Riot Games broadcast result.',
    endsAt: new Date(Date.now() + 7 * 3600 * 1000).toISOString(),
    totalPool: 289400,
    participantsCount: 1890,
    volume24h: 76500,
    options: [
      {
        id: 'opt-t1',
        label: 'T1 (Faker)',
        odds: 1.95,
        votesPercentage: 54,
        totalStaked: 156276,
        color: '#ef4444',
      },
      {
        id: 'opt-geng',
        label: 'Gen.G (Chovy)',
        odds: 1.88,
        votesPercentage: 46,
        totalStaked: 133124,
        color: '#eab308',
      },
    ],
  },
  {
    id: 'm-ai-frontier-release',
    title: 'Will Next-Gen Frontier Model release to public before Q3?',
    category: 'tech',
    status: 'upcoming',
    description:
      'Resolves to YES if a frontier AI model achieves official public rollout or API availability prior to the designated deadline.',
    rules: 'Verified through official company blog and API documentation.',
    endsAt: new Date(Date.now() + 72 * 3600 * 1000).toISOString(),
    totalPool: 195000,
    participantsCount: 1420,
    volume24h: 38200,
    options: [
      {
        id: 'opt-frontier-yes',
        label: 'YES',
        odds: 1.65,
        votesPercentage: 64,
        totalStaked: 124800,
        color: '#10b981',
      },
      {
        id: 'opt-frontier-no',
        label: 'NO',
        odds: 2.45,
        votesPercentage: 36,
        totalStaked: 70200,
        color: '#f43f5e',
      },
    ],
  },
  {
    id: 'm-sol-ath',
    title: 'Will Solana (SOL) hit a new All-Time High this month?',
    category: 'crypto',
    status: 'live',
    description:
      'Resolves to YES if SOL trades above its previous ATH ($260) on major global exchanges.',
    endsAt: new Date(Date.now() + 18 * 3600 * 1000).toISOString(),
    totalPool: 188700,
    participantsCount: 1210,
    volume24h: 44100,
    options: [
      {
        id: 'opt-sol-yes',
        label: 'YES (> $260)',
        odds: 2.10,
        votesPercentage: 48,
        totalStaked: 90576,
        color: '#a855f7',
      },
      {
        id: 'opt-sol-no',
        label: 'NO (< $260)',
        odds: 1.78,
        votesPercentage: 52,
        totalStaked: 98124,
        color: '#64748b',
      },
    ],
  },
  {
    id: 'm-cs2-navi-faze',
    title: 'NaVi vs FaZe Clan – CS2 Major Grand Final',
    category: 'esports',
    status: 'ending_soon',
    description: 'Map 1 Decider round winner in the tactical FPS showdown.',
    endsAt: new Date(Date.now() + 45 * 60 * 1000).toISOString(),
    totalPool: 165000,
    participantsCount: 1150,
    volume24h: 58000,
    options: [
      {
        id: 'opt-navi',
        label: 'Natus Vincere',
        odds: 1.82,
        votesPercentage: 56,
        totalStaked: 92400,
        color: '#eab308',
      },
      {
        id: 'opt-faze',
        label: 'FaZe Clan',
        odds: 2.05,
        votesPercentage: 44,
        totalStaked: 72600,
        color: '#ef4444',
      },
    ],
  },
  {
    id: 'm-boxoffice-billion',
    title: 'Will the summer blockbuster cross $1B global box office?',
    category: 'culture',
    status: 'upcoming',
    description:
      'Official Box Office Mojo totals after first 21 days of theatrical release.',
    endsAt: new Date(Date.now() + 120 * 3600 * 1000).toISOString(),
    totalPool: 94000,
    participantsCount: 650,
    volume24h: 18200,
    options: [
      {
        id: 'opt-box-yes',
        label: 'YES (> $1.0B)',
        odds: 1.90,
        votesPercentage: 51,
        totalStaked: 47940,
        color: '#10b981',
      },
      {
        id: 'opt-box-no',
        label: 'NO (< $1.0B)',
        odds: 1.95,
        votesPercentage: 49,
        totalStaked: 46060,
        color: '#f43f5e',
      },
    ],
  },
];

export const INITIAL_LEADERBOARD: PredictorLeaderboardItem[] = [
  {
    rank: 1,
    id: 'user-top-1',
    username: 'SatoshiProphet',
    avatar: '🧙‍♂️',
    winRate: 83.2,
    totalProfit: 142500,
    totalBets: 218,
    streak: 9,
    badge: 'Grandmaster',
  },
  {
    rank: 2,
    id: 'user-top-2',
    username: 'NeoApex',
    avatar: '⚡',
    winRate: 79.5,
    totalProfit: 98400,
    totalBets: 174,
    streak: 6,
    badge: 'Whale',
  },
  {
    rank: 3,
    id: 'user-top-3',
    username: 'CyberOracle',
    avatar: '🔮',
    winRate: 77.1,
    totalProfit: 86900,
    totalBets: 153,
    streak: 5,
    badge: 'Oracle',
  },
  {
    rank: 4,
    id: 'user-top-4',
    username: 'ViperSniper',
    avatar: '🎯',
    winRate: 74.0,
    totalProfit: 62400,
    totalBets: 130,
    streak: 4,
    badge: 'Sniper',
  },
  {
    rank: 5,
    id: 'user-top-5',
    username: 'StreakMaster',
    avatar: '🔥',
    winRate: 71.8,
    totalProfit: 54100,
    totalBets: 112,
    streak: 7,
    badge: 'Hot Streak',
  },
  {
    rank: 6,
    id: 'user-top-6',
    username: 'EchoTrader',
    avatar: '🦊',
    winRate: 69.4,
    totalProfit: 41800,
    totalBets: 95,
    streak: 3,
    badge: 'Sniper',
  },
];

export const INITIAL_USER_BETS: UserBet[] = [
  {
    id: 'bet-demo-1',
    marketId: 'm-btc-100k',
    marketTitle: 'Will Bitcoin surpass $105,000 before end of month?',
    category: 'crypto',
    optionId: 'opt-yes',
    optionLabel: 'YES (Above $105k)',
    odds: 1.82,
    stake: 500,
    potentialPayout: 910,
    status: 'active',
    createdAt: new Date(Date.now() - 3600 * 1000).toISOString(),
  },
  {
    id: 'bet-demo-2',
    marketId: 'm-t1-geng-finals',
    marketTitle: 'T1 vs Gen.G – League of Legends Final',
    category: 'esports',
    optionId: 'opt-t1',
    optionLabel: 'T1 (Faker)',
    odds: 1.95,
    stake: 300,
    potentialPayout: 585,
    status: 'active',
    createdAt: new Date(Date.now() - 2 * 3600 * 1000).toISOString(),
  },
  {
    id: 'bet-demo-3',
    marketId: 'm-sol-ath',
    marketTitle: 'Solana (SOL) 24h Price Action Up/Down',
    category: 'crypto',
    optionId: 'opt-sol-yes',
    optionLabel: 'UP',
    odds: 2.10,
    stake: 250,
    potentialPayout: 525,
    status: 'won',
    createdAt: new Date(Date.now() - 24 * 3600 * 1000).toISOString(),
    resolvedAt: new Date(Date.now() - 12 * 3600 * 1000).toISOString(),
  },
];
